import { useAtom as useAtomJotai, useAtomValue, useSetAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';

export const useAtom = useAtomJotai;
export const useValue = useAtomValue;
export const useReset = useResetAtom;
export const useSetValue = useSetAtom;
